<template>
    <v-img
        class="popup-preview"
        :class="{ 'interactive': isInteractive }"
        :max-height="height"
        :src="imageUrl"
        :gradient="isPlotDisabled ? 'rgba(100, 100, 100, .4), rgba(100, 100, 100, .4)' : null"
        @load="imageLoading"
        @click.prevent="goToPlot"
        contain
    >
        <v-skeleton-loader
            v-if="!loaded"
            :max-height="height"
            type="image"
        />
    </v-img>
</template>

<script>
    export default {
        name: 'Preview',
        props: {
            imageUrl: {
                type: String,
                required: true
            },
            height: {
                type: Number,
                required: true
            },
            width: {
                type: [Number, String],
                required: false
            },
            isInteractive: {
                type: Boolean,
                required: true
            },
            isPlotDisabled: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                loaded: false
            }
        },
        methods: {
            imageLoading () {
                this.loaded = true
            },
            goToPlot() {
                if (this.isInteractive)
                    this.$emit('go-to-plot');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .popup-preview {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        &.interactive {
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/components/Preview.vue